import { useState } from 'react';
import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { debounce } from '../../../utils/debounce.es.js';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { Typography } from '../../../theme/Typography.es.js';
import { Vars } from './Vars.es.js';

const Styles = labelStyles("Table", {
  root: css`
    display: block;
    width: 100%;
    position: relative;

    &[data-scrollable] {
      overflow: auto;

      &[data-scrolled-horz] {
        ${Vars.frozenCellHorzShadowOpacity}: 1;
      }

      &[data-scrolled-vert] {
        ${Vars.frozenCellVertShadowOpacity}: 1;
      }
    }
  `,
  table: css`
    display: table;
    border-spacing: 0;
    &[data-collapse] {
      border-collapse: collapse;
    }

    &[data-kind='standard'] {
      width: 100%;
      ${Typography.Body1Multiline};
      color: ${Colors.TextDefault};

      th,
      td {
        border-bottom: 1px solid ${Colors.StrokeWeaker};
        background-color: ${Colors.BackgroundWeaker};
        padding: var(--zds-space-12);
      }

      th {
        font-weight: unset;
      }

      tbody tr:hover {
        th,
        td {
          background-color: ${Colors.UiPrimaryWeakest};
        }
      }
    }
  `
});
const Table = ({ scrollable, children, collapse = false, kind = "standard" }) => {
  const [isScrolledHorz, setIsScrolledHorz] = useState(false);
  const [isScrolledVert, setIsScrolledVert] = useState(false);
  const setScroll = debounce((target) => {
    const { scrollLeft, scrollTop } = target;
    setIsScrolledHorz(scrollLeft > 0);
    setIsScrolledVert(scrollTop > 0);
  }, 20);
  const onScroll = (e) => {
    setScroll(e.target);
  };
  return jsx(
    "div",
    { css: Styles.root, "data-scrollable": scrollable ? "" : void 0, "data-scrolled-horz": isScrolledHorz ? "" : void 0, "data-scrolled-vert": isScrolledVert ? "" : void 0, "data-zds": true, onScroll },
    jsx("table", { css: Styles.table, "data-collapse": collapse ? "" : void 0, "data-kind": kind, "data-zds": true, role: "table" }, children)
  );
};

export { Table };
//# sourceMappingURL=Table.es.js.map
